import React, { useEffect, useState } from 'react'

import Brandy from '../../Brandy'
import Price from '../../Price'
import Bullets from '../Bullets'
import Details from '../Details'
import Label from '../Label'
import MainContent from '../MainContent'
import NameAndDescription from '../NameAndDescription'
import * as Styled from './DefaultPackageCard.styles'

const DefaultPackageCard = ({
  labelData,
  labelRef,
  height,
  packageData,
  modal,
  children,
  content,
}) => (
  <Styled.PackageCard className="wrapper default">
    {labelData && ( // eslint-disable-line
      <Label
        labelRef={labelRef}
        height={height}
        labelType={labelData?.type}
        text={labelData?.text}
      />
    )}

    <NameAndDescription
      name={packageData.name}
      description={packageData.description}
    />

    <Details packageData={packageData.details} />

    {packageData?.price?.amount && (
      <Price
        className="price"
        {...packageData?.price}
        inPackageCard
        nutrition={packageData?.nutrition}
        priceOld={packageData?.priceOld}
      />
    )}

    {packageData?.price?.custom && (
      <Styled.CustomTextContainer>
        <Styled.CustomText inPackageCard>
          {packageData?.price?.custom}
        </Styled.CustomText>
        {packageData?.price?.disclaimer && (
          <Brandy
            className="bullet-disclaimer"
            symbol={packageData.price?.disclaimer?.symbol}
            text={packageData.price?.disclaimer?.text}
            variant="legal"
          />
        )}
      </Styled.CustomTextContainer>
    )}

    {modal && <span className="modal">{modal}</span>}

    <Bullets bullets={packageData?.bullets} />

    {children}
    <MainContent content={content} />
  </Styled.PackageCard>
)

const DefaultPackageCardWrapper = (props) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [setMounted])

  return mounted && <DefaultPackageCard {...props} />
}

/* eslint-enable react/no-danger */
export default DefaultPackageCardWrapper
